import React, { useState } from 'react';


const SetTimeModal = ({ device, onClose, onSubmit, isSubmitting }) => {
  const [time, setTime] = useState(new Date().toTimeString().slice(0, 5));

  const handleSyncTime = () => {
    // Get current time in HH:MM format
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    setTime(`${hours}:${minutes}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ time });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Set Time for {device.serial_number}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="device-time">
              Device Time (24-hour format)
            </label>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <input
                id="device-time"
                type="time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                className="form-input"
                required
              />
              <button
                type="button"
                onClick={handleSyncTime}
                className="button button-secondary"
              >
                Sync
              </button>
            </div>
          </div>
          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              className="button button-secondary"
            >
              Cancel
            </button>
            <button type="submit" className="button action-button" disabled={isSubmitting}>
                {isSubmitting ? 'Setting...' : 'Set Time'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SetTimeModal;